<template>
<body style="background-color:#D6D6D6">
    <div class="capacitacion">
        
        
        <!--<h1 class="pl-5 ml-4 pt-5 hidden-xs-only" style="color:#942C75; font-family:Poppins; font-size:1.8vw; font-weight:500">{{title}}</h1>
        <h1 class="pl-5 ml-1 pt-5 hidden-sm-and-up" style="color:#942C75; font-family:Poppins; font-size:4vw; font-weight:500">{{title}}</h1>-->
        <ContentCapacitacion>

        </ContentCapacitacion>

    </div>
    </body>
</template>


<script>
import ContentCapacitacion from "@/components/ContentCapacitacion.vue"




export default {
   
    components:{
       ContentCapacitacion,
     },

     data(){
         return{
             
             title:"VIDEOS CAPACITACION",
             
         }
     },
     /*beforeMount(){
      alert("Holaa tu primera capacitacion sera en octubre");
    }*/

    
    
}
</script>

<style scoped>
  
</style>

